import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
import { calTagNameSchema } from './cal-tag-name-schema.js';
export const renameCalTagInputSchema = z.object({
    id: requiredUuidString('Tag is required.', 'Invalid tag ID.'),
    name: calTagNameSchema,
});
//# sourceMappingURL=rename-cal-tag-input.js.map